var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLearningCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 68,
    viewBox: "0 0 70 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 15.0171V60.4355C34.524 60.4355 34.02 60.3505 33.628 60.1238L33.516 60.0671C28.14 57.0921 18.76 53.9755 12.684 53.1538L11.872 53.0405C9.184 52.7005 7 50.1505 7 47.4305V13.2038C7 9.83212 9.716 7.28212 13.048 7.56545C18.928 8.04712 27.832 11.0505 32.816 14.1955L33.516 14.6205C33.936 14.8755 34.468 15.0171 35 15.0171Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1431 52.6571L57.1431 52.6571L57.1373 52.6579C50.9707 53.488 41.5026 56.6531 36.0721 59.6869L36.0618 59.6927L36.0517 59.699C35.9007 59.793 35.7183 59.8586 35.5 59.8964V15.4813C35.9447 15.418 36.3754 15.271 36.7435 15.0476L36.7508 15.0431L36.7579 15.0385L37.2312 14.7286C42.142 11.6028 50.9788 8.60197 56.7778 8.0935H56.924H56.9452L56.9664 8.0917C60.0031 7.83348 62.5 10.1212 62.5 13.2318V47.4301C62.5 49.9064 60.4955 52.2362 58.0661 52.5439C58.0658 52.544 58.0655 52.544 58.0653 52.544L57.1431 52.6571Z",
    fill: "url(#paint0_linear_9815_7449)",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0992 26.1807H16.7992C15.6512 26.1807 14.6992 25.2173 14.6992 24.0557C14.6992 22.894 15.6512 21.9307 16.7992 21.9307H23.0992C24.2472 21.9307 25.1992 22.894 25.1992 24.0557C25.1992 25.2173 24.2472 26.1807 23.0992 26.1807Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1992 34.6807H16.7992C15.6512 34.6807 14.6992 33.7173 14.6992 32.5557C14.6992 31.394 15.6512 30.4307 16.7992 30.4307H25.1992C26.3472 30.4307 27.2992 31.394 27.2992 32.5557C27.2992 33.7173 26.3472 34.6807 25.1992 34.6807Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9815_7449",
    x1: 53.6123,
    y1: 40.489,
    x2: 27.7589,
    y2: 41.4055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ACCFB",
    stopOpacity: 0.72
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningCheckIcon);
export default __webpack_public_path__ + "static/media/learning-check-icon.945ed5f7d5d7ef44c6e296413f786fc8.svg";
export { ForwardRef as ReactComponent };